import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';
import React, { useEffect, useState } from 'react';
import { UnstyledButton } from 'vl-common/src/components/UnstyledButton';

export function DismissibleAlert({
  alert
}: {
  alert: {
    message: string;
    type?: React.ComponentProps<typeof Alert>['type'];
  };
}) {
  const { t } = useTranslation('common');
  const [showAlert, setShowAlert] = useState(false);

  function handleAlertClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    setShowAlert(false);
  }

  useEffect(() => {
    setShowAlert(!!alert?.message);
  }, [alert]);

  return (
    <div
      style={{
        position: 'relative',
        visibility: showAlert ? 'initial' : 'hidden',
        cursor: 'pointer'
      }}
    >
      <UnstyledButton
        data-testid="dismiss-button"
        aria-label={t('dismiss')}
        onClick={handleAlertClick}
        style={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          zIndex: 10
        }}
      />
      <Alert
        className="login-alert"
        style={{ margin: '1rem 0' }}
        message={alert?.message || ' '}
        type={alert?.type}
        showIcon
        closable
      />
    </div>
  );
}

export default DismissibleAlert;
